// extracted by mini-css-extract-plugin
export default {"teamsContainer":"TeamList_teamsContainer__XS8gj","team":"TeamList_team__O9j2c","participants":"TeamList_participants__btpM+"};